import { isSameDay, format, isAfter, addWeeks, addHours } from 'date-fns';

export const expiredAfterHours = (input: Date) => {
  return isAfter(addHours(new Date(), -2), input);
};

export const formatDate = (input: Date) => {
  if (isSameDay(input, new Date())) {
    return format(input, "p, 'Today'");
  } else if (isAfter(addWeeks(new Date(), 1), input)) {
    return format(input, "p, 'next' eeee 'the' do");
  } else {
    return format(input, 'p, MMM do');
  }
};
